import OrderCheckoutModal from './OrderCheckoutModal';

export default OrderCheckoutModal;
